import type { Group } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/insight-roles.tsx';
import type { GroupsPickerOption } from './types.tsx';

export const transformGroupToSelectOption = ({ groupId, name }: Group): GroupsPickerOption => ({
	label: name,
	value: groupId ?? name,
});

export const transformOptionToGroup = ({ value, label }: GroupsPickerOption): Group => ({
	groupId: value,
	name: label,
});
